import configState from '../state/config';
var reason = {
    empty: 'contains undefined/null/NaN',
    html: 'contains html',
    placeholder: 'contains unformatted placeholder {{...}}',
};
var htmlRegex = /<\/?(?:html|head|title|base|link|meta|style|script|noscript|body|section|nav|article|aside|h[1-6]|header|footer|address|p|hr|pre|blockquote|ol|ul|li|dl|dt|dd|figure|figcaption|div|a|em|strong|small|s|cite|q|dfn|abbr|ruby|rb|rt|rp|bdi|bdo|span|br|wbr|ins|del|img|iframe|embed|object|param|video|audio|source|track|canvas|map|area|svg|math|table|caption|colgroup|col|tbody|thead|tfoot|tr|td|th|form|fieldset|legend|label|input|button|select|datalist|optgroup|option|textarea|keygen|output|progress|meter|details|summary|menu|menuitem|dialog|script|template|slot|custom-element)(?:\s[^>]*)?>/i;
var placeholderRegex = /\{\{[a-zA-Z]+\}\}/;
export function baseValidation(text) {
    if (/^(undefined|null|NaN)$/.test(text)) {
        return { value: false, reason: reason.empty };
    }
    if (placeholderRegex.test(text)) {
        return { value: false, reason: reason.placeholder };
    }
    if (htmlRegex.test(text)) {
        return { value: false, reason: reason.html };
    }
    return {
        value: true,
    };
}
export function validate(text) {
    var _a, _b;
    if ((_a = configState.config) === null || _a === void 0 ? void 0 : _a.customValidation) {
        return (_b = configState.config) === null || _b === void 0 ? void 0 : _b.customValidation(text);
    }
    else {
        return baseValidation(text);
    }
}
